<div [ngClass]="activeToggleClasses">
  <div class="wpdh-container">
    <router-outlet></router-outlet>
  </div>
</div>
<app-breakpoint></app-breakpoint>
@if (globals.isBrowser) {
<app-search-window></app-search-window>
}
<loader [loadingContent]="loadingContent"></loader>
